import Route from 'mewe/routes/route';
import { Theme } from 'mewe/constants';
import {
  getFollowersCountries,
  fetchFollowersCountries,
  getFollowersIntervals,
  fetchFollowersIntervals,
} from 'mewe/fetchers/fetch-page-analytics';
import isUndefined from 'mewe/utils/isUndefined';

const nowMinusDays = (days) => {
  const now = new Date(),
    dayMillis = days * 6 * 24 * 60 * 60 * 1000;

  return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0) - dayMillis;
};

export default Route.extend({
  theme: Theme.PAGE,
  leaf: true,

  id() {
    return this.modelFor('app.publicid').page.id;
  },

  queryParams: {
    interval: {
      refreshModel: true,
    },
    ref: {
      refreshModel: true,
    },
  },

  beforeModel(transition) {
    const queryParams = (transition.to && transition.to.queryParams) || {},
      id = this.id();

    if (!queryParams.ref) queryParams.ref = nowMinusDays(6);
    if (!queryParams.interval) queryParams.interval = 7;

    if (isUndefined(getFollowersCountries(id).items)) fetchFollowersCountries(id);
    if (isUndefined(getFollowersIntervals(id, queryParams).items)) fetchFollowersIntervals(id, queryParams);
  },

  model(params) {
    if (!params.ref) params.ref = nowMinusDays(6);
    if (!params.interval) params.interval = 7;

    const id = this.id();
    return {
      app: this.modelFor('app'),
      page: this.modelFor('app.publicid').page,
      followersCountries: getFollowersCountries(id),
      followersIntervals: getFollowersIntervals(id, params),
      ref: params.ref,
      interval: params.interval,
    };
  },

  actions: {
    selectDateRange(range) {
      let intervalDays = 7;
      switch (range.range) {
        case 90:
          intervalDays = 90;
          break;
        case 30:
          intervalDays = 30;
          break;
      }

      this.controller.setProperties({
        ref: nowMinusDays(range.range - 1),
        interval: intervalDays,
      });
    },
  },
});
